import React from 'react';
import {Message} from 'ui';

interface TableSelectedRowCountInterface {
    rows: any[];
}

const TableSelectedRowCount: React.FC<TableSelectedRowCountInterface> = ({rows}) => {
    return (
        <div>
            {rows ? rows.length : 0}
            <Message id='users.rows_selected' />
        </div>
    );
};

export default TableSelectedRowCount;